// Announcements + maintenance windows (scheduler-service via the gateway). P1-6c.
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);

export interface Announcement {
  id: string;
  level: string; // info | warning | critical
  message: string;
  audience: string; // all | tenant_admins | operators
  dismissible: boolean;
  active: boolean;
  starts_at: string;
  ends_at?: string | null;
  created_at: string;
}

export interface MaintenanceWindow {
  id: string;
  title: string;
  description?: string | null;
  affected_services: string[];
  scheduled_start: string;
  scheduled_end: string;
  status: string; // scheduled | in_progress | completed | cancelled
  is_public: boolean;
  created_at: string;
}

const ANN = `${API_V1}/announcements/platform`;
const MW = `${API_V1}/maintenance/platform`;

export const listAnnouncements = () =>
  axios.get<{ announcements: Announcement[] }>(ANN).then((r) => r.data.announcements || []);
export const createAnnouncement = (input: {
  level?: string; message: string; audience?: string; dismissible?: boolean; ends_at?: string;
}) => axios.post<Announcement>(ANN, input).then((r) => r.data);
export const patchAnnouncement = (id: string, patch: Partial<{ level: string; message: string; audience: string; active: boolean; ends_at: string }>) =>
  axios.patch<Announcement>(`${ANN}/${id}`, patch).then((r) => r.data);

export const listMaintenance = () =>
  axios.get<{ windows: MaintenanceWindow[] }>(MW).then((r) => r.data.windows || []);
export const createMaintenance = (input: {
  title: string; description?: string; affected_services?: string[]; scheduled_start: string; scheduled_end: string; is_public?: boolean;
}) => axios.post<MaintenanceWindow>(MW, input).then((r) => r.data);
export const patchMaintenance = (id: string, patch: Partial<{ status: string; is_public: boolean; title: string; description: string }>) =>
  axios.patch<MaintenanceWindow>(`${MW}/${id}`, patch).then((r) => r.data);
